import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { CreateProductionSiteFieldDefinition } from "@tfg/types/schemas/modules/traceability/queries/create-production-site-field-definition.dto"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useCreateProductionSiteFieldDefinitionMutation = (
  orgId: string,
  options?: UseMutationOptions<
    unknown,
    AxiosError,
    CreateProductionSiteFieldDefinition
  >
) =>
  useMutation({
    mutationFn: async (
      prodSiteFieldDef: CreateProductionSiteFieldDefinition
    ) => {
      return await httpClient.post(
        `/admin/traceability/create-production-site-field-definition`,
        prodSiteFieldDef
      )
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)

      showSuccessNotification({
        title: "Success",
        message: "Production field definition created",
      })

      queryClient.invalidateQueries({
        queryKey: ["prodSiteFieldDefs", orgId],
      })
    },
    onError: (error: AxiosError) => {
      showAxiosError({
        notificationTitle: "Error",
        notificationMessage: error.message,
        showNotification: true,
        error,
      })
    },
  })
